import React from 'react'

import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'
import { useAuth } from '../AuthProvider/AuthProvider'

import CustomerInformationForm from './CustomerInformationForm/CustomerInformationForm'
import UpdatePasswordForm from './UpdatePasswordForm/UpdatePasswordForm'
import SavedCreditCardForm from './SavedCreditCardForm/SavedCreditCardForm'
import AccountHeader from '../AccountHeader/AccountHeader'
import Progress from '../Progress/Progress'

import { formatTel } from '../../utils/form-utils'
import { CreditCardProvider } from '../CreditCardProvider/CreditCardProvider'
import { ToastContainer } from 'react-toastify'
import { SavedAddressForm } from './SavedAddressForm/SavedAddressForm'
import { FlagOn } from '../FeatureFlag/FeatureFlag'

import style from './AccountPage.css'

const { toastContainer, toastWrapper } = style

const getInitialValues = (user = {}) => {
  const { firstName, lastName, email, phone } = user

  return {
    customerFirstName: firstName || '',
    customerLastName: lastName || '',
    customerEmail: email || '',
    customerTel: formatTel(phone) || ''
  }
}

const AccountPage = () => {
  const { user, loading } = useAuth()
  const { getRestaurantPath, restaurantGuid } = useRestaurant()
  return (
    <div styleName='page'>
      <AccountHeader to={getRestaurantPath()} title='My Account' />
      { loading ? <Progress eventData={{ category: 'AccountPage' }} />
        : (
          <React.Fragment>
            <CustomerInformationForm initialValues={getInitialValues(user)} />
            <UpdatePasswordForm restaurantGuid={restaurantGuid} />
            <FlagOn name='oo-v3-delivery'>
              <SavedAddressForm />
            </FlagOn>
            <CreditCardProvider>
              <SavedCreditCardForm />
            </CreditCardProvider>
          </React.Fragment>
        )
      }
      <ToastContainer
        hideProgressBar
        closeButton={false}
        className={toastContainer}
        toastClassName={toastWrapper}
        position={'top-center'}
      />
    </div>
  )
}

export default AccountPage
